<template>
    <el-table
        ref="cus-table"
        :default-sort="defaultSort"
        :data="_datalist"
        @row-click="rowClick"
        @row-dblclick="rowDbclick"
        @row-contextmenu="rowContextMenu"
        @select-all="selectAll"
        @header-dragend="changeColWidth"
        @scrollToBottom="scrollToBottom"
        :expand-row-keys="expandRow"
        :stripe="stripe"
        :style="tableStyle"
        class="el-table--scrollable-y"
        :tree-props="{ children: 'children', hasChildren: 'hasChildren' }"
        empty-text="暂无数据"
        :row-key="setRowKeys"
        :indent="10"
        :highlight-current-row="!selection"
        border
        tooltip-effect="light"
        :row-class-name="rowClass"
        :row-style="tableRowStyle"
        :cell-class-name="cellClass"
        :span-method="loadSpanMethod"
        @sort-change="sortChange"
        @selection-change="handleSelectionChange"
        :header-cell-style="headerStyle"
    >
        <!--额外部分标题-->
                <el-table-column type="expand" v-if="expandColumn && expandColumn[0] && expandColumn[0].length > 0">
            <template slot-scope="scope">
                <el-row v-for="(g, index) in expandColumn" :key="index">
                    <el-col :span="12" v-for="(item, index) in g" :key="index">
                        <el-row>
                            <el-col :span="8" class="padding20 padding-none-v">
                                <div>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{ item.label.content || item.label }}:</div>
                            </el-col>
                            <el-col :span="16">
                                <TextFormatter
                                    :class="item.type"
                                    v-if="filter_readonly(item, scope.row)"
                                    :type="item.type"
                                    v-model="scope.row[item.prop]"
                                    :options="filter_option(item, scope.row)"
                                    @extrabutton-click="ExtraButtonClick($event, { index: scope.$index, row: scope.row })"
                                ></TextFormatter>

                                <item-input
                                    v-else
                                    :type="item.type"
                                    v-model="scope.row[item.prop]"
                                    :options="filter_option(item, scope.row)"
                                    :showCount="showCount(item)"
                                    v-bind="item.config"
                                    @activeRow="setActiveRow(arguments)"
                                    @input="ItemChange({ index: scope.$index, row: scope.row, prop: item.prop, column: item })"
                                    @change="ItemOnBlurChange(arguments, { index: scope.$index, row: scope.row, prop: item.prop, column: item })"
                                    @extrabutton-click="ExtraButtonClick($event, { index: scope.$index, row: scope.row, prop: item.prop })"
                                    :selectColumn="item.selectColumn"
                                ></item-input>
                            </el-col>
                        </el-row>
                    </el-col>
                </el-row>
            </template>
        </el-table-column>
        <el-table-column v-if="selection" type="selection" :reserve-selection="reserveSelection" label="" :fixed="fixedLeftColumn.length > 0" header-align="center" align="center" width="30">
        </el-table-column>
        <el-table-column v-if="showSequence" type="index" label="序号" :fixed="fixedLeftColumn.length > 0" align="center" width="40" header-align="center"> </el-table-column>
        <el-table-column v-if="hasChildren" prop="___sequence_no" label="序号" :fixed="fixedLeftColumn.length > 0" header-align="center" align="center" width="70"> </el-table-column>
        <!--正常展示标题 :label="item.label"-->
        <el-table-column
            v-for="(item, index) in listColumn"
            :key="`${item.prop}${index}`"
            :prop="item.prop"
            :width="item.width"
            :label="item.label"
            :filters="item.filters && transfer(item.options)"
            :filter-method="item.filters && filterHandler"
            :show-overflow-tooltip="showTooltip(item)"
            :fixed="item.fixed"
            :sortable="item.sortable ? true : false"
            :sort-method="(a, b) => sortHandle(a, b, item.prop, item)"
            header-align="center"
            :align="(item.config && item.config.align) || 'center'"
        >
            <template slot="header" v-if="item.type == 'checkbox'">
                <el-checkbox size="mini" v-model="checkboxs[index]" @change="checkedChange(item, index)"></el-checkbox>
            </template>
            <div v-if="item.type == 'custom'" slot-scope="scope">
                <slot name="column" :index="scope.$index" :row="scope.row" :column="item"></slot>
                <slot :name="item.prop" :index="scope.$index" :row="scope.row" :column="item"></slot>
            </div>
            <div
                @click="active_item = [scope.$index, index]"
                v-else
                slot-scope="scope"
                :key="item.prop"
                :class="getbgclass(item, scope)"
                style="min-height: 20px; width: 100%"
                :style="item.cellstyle != '' ? scope.row[item.prop + 'style'] : ''"
            >
                <TextFormatter
                    :class="item.type"
                    v-if="filter_readonly(item, scope.row)"
                    :type="item.type"
                    v-model="scope.row[item.prop]"
                    v-bind="item.config"
                    :slotValue="scope.row[item.slotCol]"
                    :options="filter_option(item, scope.row)"
                    :decimal_places="item.decimal_places"
                    @extrabutton-click="ExtraButtonClick($event, { index: scope.$index, row: scope.row })"
                ></TextFormatter>
                <item-input
                    :autofocus="active_item[0] == scope.$index && active_item[1] == index"
                    v-else
                    :type="item.type"
                    :allowCreate="item.allowCreate"
                    v-model="scope.row[item.prop]"
                    :options="filter_option(item, scope.row)"
                    :showCount="showCount(item)"
                    @input="ItemChange({ index: scope.$index, row: scope.row, prop: item.prop, column: item })"
                    v-bind="item.config"
                    :isShowPhoto="item.isShowPhoto"
                    :decimal_places="item.decimal_places"
                    :slotValue="scope.row[item.slotCol]"
                    @activeRow="setActiveRow(arguments)"
                    @extrabutton-click="ExtraButtonClick($event, { index: scope.$index, row: scope.row, prop: item.prop, op: $event.op })"
                    @blur="ItemOnBlur({ index: scope.$index, row: scope.row, prop: item.prop, column: item })"
                    @change="ItemOnBlurChange(arguments, { index: scope.$index, row: scope.row, prop: item.prop, column: item })"
                    :clearable="(!item.config || item.config.clearable == undefined) && clearable"
                    :selectColumn="item.selectColumn"
                ></item-input>
            </div>
        </el-table-column>
        <!--操作区域-->
        <el-table-column v-if="buttons && buttons.length > 0" fixed="right" label="操作" header-align="center" :width="buttonsWidth" align="center">
            <template slot-scope="scope">
                <!-- <el-row class="align-center"> -->
                <el-button
                    v-has-permission="button.permission"
                    v-for="(button, index) in buttons"
                    :key="index"
                    plain
                    :class="`${button.emit} ${button.class}`"
                    @click.stop="$emit('extrabutton-click', { emit: button.emit, index: scope.$index, row: scope.row })"
                    size="mini"
                    :type="button.type"
                >
                    <TextFormatter v-if="button.icon" type="icons" v-model="button.icon"></TextFormatter>
                    {{ button.label }}
                </el-button>
                <!-- </el-row> -->
            </template>
        </el-table-column>
    </el-table>
</template>

<script>
/*
 *   columns:[{
 *     type:"string",
 *     prop:"id",
 *     label:"ID",
 *     width:"180",
 *     isListable:false,
 *     isExpand:false,
 *     isEditable:false,
 *     isKey:false
 *   }]
 * */
import TextFormatter from './TextFormatter'
import Sortable from 'sortablejs'
// import { mapGetters } from 'vuex'
export default {
    name: `ListView`,
    components: { TextFormatter },
    props: {
        datalist: { type: Array },
        columns: { type: Array },
        buttons: { type: Array },
        selection: { type: Boolean },
        listenRowChange: { type: Boolean, default: false },
        showSequence: { type: Boolean, default: true },
        chargeStyle: { type: Boolean, default: false },
        rowNoStyle: { type: Boolean, default: false },
        sort: { type: Boolean, default: false },
        rowDropDisabled: { type: Boolean, default: true },
        tableHeight: { type: Number },
        tableStyle: { type: String },
        headerStyle: { type: Object },
        clearable: { type: Boolean, default: true },
        spanMethod: { type: Function },
        stripe: { type: Boolean, default: true },
        defaultSort: { type: Object },
        reserveSelection: { type: Boolean, default: false },
        singleChoice: { type: Boolean, default: false }
    },
    data() {
        return {
            isAllSelect: false,
            expandRow: [],
            multipleSelection: [],
            isDragging: false,
            active_row: undefined,
            active_item: [],
            checkboxs: [],
            isCtrl: false,
            selected: [],
            choosen: undefined,
            tableBody: null,
            order: ``
        }
    },
    created() {
        this.$nextTick(() => {
            this.rowDrop()
            this.setTableheight(0)
        })
    },
    mounted() {
        var isWin = navigator.platform == `Win32` || navigator.platform == `Windows`
        var isMac = navigator.platform == `Mac68K` || navigator.platform == `MacPPC` || navigator.platform == `Macintosh` || navigator.platform == `MacIntel`
        document.addEventListener(`keydown`, e => {
            if ((e.keyCode === 17 && isWin) || (e.keyCode === 91 && isMac)) {
                this.isCtrl = true
            }
        })
        document.addEventListener(`keyup`, e => {
            if ((e.keyCode === 17 && isWin) || (e.keyCode === 91 && isMac)) {
                this.isCtrl = false
            }
        })

        this.tableBody = this.$refs[`cus-table`].bodyWrapper
        this.tableBody.addEventListener(`scroll`, () => {
            let scrollTop = this.tableBody.scrollTop
            let windowHeight = this.tableBody.clientHeight
            let scrollHeight = this.tableBody.scrollHeight
            if (scrollTop + windowHeight > scrollHeight - 2) {
                this.$emit(`scrollToEnd`)
            }
        })
    },
    computed: {
        _datalist() {
            if (this.defaultSort && this.defaultSort.prop) {
                let that = this
                that.sortOrder(that.datalist, that.defaultSort.prop, that.order)
            }
            return _.map(this.datalist, (d, index) => {
                d.___sequence_no = `${index + 1}`
                return d
            })
        },
        _tableHeight() {
            return this.tableHeight
        },
        hasChildren() {
            return _.findIndex(this.datalist, d => d.children && d.children.length > 0) > -1
        },
        listColumn() {
            let r = _.filter(this.columns, { isListable: true })
            return r
        },
        hasFixed() {
            return _.some(this.columns, lc => {
                return lc.fixed !== undefined
            })
        },
        fixedLeftColumn() {
            return _.filter(this.listColumn, lc => {
                return lc.fixed == `left`
            })
        },
        expandColumn() {
            let expandColumns = _.filter(this.columns, { isExpand: true })
            let newExpandColumns = expandColumns.map(function(value, index, array) {
                return Object.assign({}, value, { num: index / 2 })
            })
            return _.groupBy(newExpandColumns, function(c) {
                return Math.floor(c.num)
            })
        },
        keyColumns() {
            return _.filter(this.columns, { isKey: true })
        },
        buttonsWidth() {
            let w = 0
            _.forEach(this.buttons, b => {
                w += b.label.length
                w += b.icon && b.icon.length > 0 ? 1 : 0
            })
            w += w * 14 + this.buttons.length * 8 // button 左右边距 16px   1个汉字14px
            return w + (this.buttons.length - 1) * 10 + 30 // button 之间间隔 5px   td padding 5px 额外再给10px富余
        },
        pre_column_len() {
            return this.selection ? 1 : 0 + this.showSequence ? 1 : 0 + (this.expandColumn && this.expandColumn[0] && this.expandColumn[0].length > 0 ? 1 : 0)
        }
    },
    methods: {
        getbgclass(item, scope) {
            if (this.chargeStyle || this.rowNoStyle) { // 麻醉计费编辑框不需要背景色
                return { 'cursorstyle': !this.filter_readonly2(item, scope.row), ellipsis: this.filter_readonly(item, scope.row) }
            }
            return { 'bg-write': !this.filter_readonly2(item, scope.row), ellipsis: this.filter_readonly(item, scope.row) }
        },
        setTableheight(interval) {
            let el = this.$refs[`cus-table`] && this.$refs[`cus-table`].$el.querySelector(`.el-table__body-wrapper`)
            let elFixed = this.$refs[`cus-table`] && this.$refs[`cus-table`].$el.querySelector(`.el-table__fixed-body-wrapper`)
            let elHeader = this.$refs[`cus-table`] && this.$refs[`cus-table`].$el.querySelector(`.el-table__header-wrapper`)
            el && el.style && (el.style.height = `${this.tableHeight - elHeader.offsetHeight - 5}px`)
            if (elFixed && elFixed.style) {
                elFixed.style.height = `${this.tableHeight - elHeader.offsetHeight - 5}px`
                elFixed.style.right = `8px`
            } else if (this.hasFixed && interval < 1000) {
                setTimeout(() => {
                    this.setTableheight(interval + 100)
                }, interval)
            }
        },
        catKeyVal(row) {
            let k = ``
            for (let o in this.keyColumns) {
                k += `_` + row[this.keyColumns[o].prop]
            }
            return k
        },
        transfer(data) {
            return _.map(data, d => {
                return {
                    value: d.value,
                    text: d.label
                }
            })
        },
        showTooltip(item) {
            if (item.tooltip == true) {
                return true
            }
            if (item.tooltip == false) {
                return false
            }
            return item.readonly == true || item.readonly == undefined
        },
        filterHandler(value, row, column) {
            const property = column[`property`]
            return row[property] === value
        },
        rowClick(row, event, column) {
            if (this.isCtrl) {
                this.$refs[`cus-table`].toggleRowSelection(row)
            }
            let k = this.catKeyVal(row)
            this.active_row = k
            let r = []
            r.push(k)
            this.$emit(`extrabutton-click`, { emit: `rowClick`, row, event, column })
            this.expandRow = r
        },
        rowDbclick(row, event, column) {
            if (this.isCtrl) {
                this.$refs[`cus-table`].toggleRowSelection(row)
            }
            let k = this.catKeyVal(row)
            this.active_row = k
            let r = []
            r.push(k)
            this.$emit(`extrabutton-click`, { emit: `rowDbclick`, row, event, column })
            this.expandRow = r
        },
        rowContextMenu(row, column, event) {
            if (this.isCtrl) {
                this.$refs[`cus-table`].toggleRowSelection(row)
            }
            let k = this.catKeyVal(row)
            this.active_row = k
            let r = []
            r.push(k)
            this.$emit(`extrabutton-click`, { emit: `rowContextMenu`, row, event, column })
            this.expandRow = r
        },
        selectAll(selection) {
            this.isAllSelect = !this.isAllSelect
            if (this.isAllSelect) {
                for (let row of this.datalist) {
                    this.selectOne(row, true)
                }
            } else {
                for (let row of this.datalist) {
                    this.selectOne(row, false)
                }
            }
            this.$emit(`selectAll`, this.isAllSelect)
        },
        changeColWidth(nw, ow, col, evt) {
            this.$emit(`changeColWidth`, nw, ow, col, evt)
        },
        scrollToBottom() {
            let scrollEl = this.$refs[`cus-table`].bodyWrapper
            scrollEl.scrollTo({ top: 50000, behavior: `smooth` })
        },
        selectOne(row, checked) {
            row.checked = checked
            this.$refs[`cus-table`].toggleRowSelection(row, checked)
        },
        setRowKeys(row) {
            return this.catKeyVal(row)
        },
        ExtraButtonClick({ emit }, { index, row, op }) {
            this.$emit(`extrabutton-click`, { emit: emit, index: index, row: row, op: op })
        },
        setActiveRow(args) {
            let _this = this
            let rowIndex = args[0]
            let cellIndex = args[1]
            let direction = args[2]
            let row = _this.datalist[rowIndex]
            while (row && row.enum_charge_status != 0 && row.enum_charge_status != 2) {
                rowIndex = direction == `down` ? rowIndex + 1 : rowIndex - 1
                row = _this.datalist[rowIndex]
            }

            if (this.isCtrl) {
                this.$refs[`cus-table`].toggleRowSelection(row)
            } else {
                this.$refs[`cus-table`].setCurrentRow(row)
            }
            if (row) {
                let k = this.catKeyVal(row)
                this.active_row = k
                let r = []
                r.push(k)
                this.expandRow = r
                _this.$nextTick(() => {
                    let activeRow = this.$refs[`cus-table`].$el.querySelector(`.el-table__body-wrapper`).querySelectorAll(`.el-table__row`)[rowIndex]
                    if (activeRow && activeRow.children[cellIndex]) {
                        let activeInput = activeRow.children[cellIndex].getElementsByTagName(`input`)[0]
                        activeInput && activeInput.focus()
                        activeInput && activeInput.select()
                    }
                })
            }
        },
        ItemChange({ index, row, prop, column }) {
            if (column.change) {
                column.change(this, { index, row, prop, column })
            }
            this.$emit(`change`, { index, row, prop, area: `list` })
        },
        ItemOnBlur({ index, row, prop, column }) {
            if (column.blur) {
                column.blur(this, { index, row, prop })
            }
            this.$emit(`blur`, { index, row, prop, area: `list` })
        },
        ItemOnBlurChange(args, { index, row, prop, column }) {
            let changetext = args[0]
            let changeid = args[1]
            if (column.blurchange) {
                column.blurchange(this, { changetext, changeid, index, row, prop })
            }
            // this.$emit(`blurchange`, { changetext, changeid, index, row, prop, area: `list` })
        },
        handleSelectionChange(val) {
            if (this.singleChoice) {
                if (val.length > 1) {
                    this.$refs[`cus-table`].clearSelection()
                    this.$refs[`cus-table`].toggleRowSelection(val.pop())
                } else if (val.length == 1) {
                    this.selected = val
                    this.$emit(`extrabutton-click`, { emit: `selectionSingleChoiceChange`, row: val[0] })
                }
            } else {
                if (this.selected.length > val.length) {
                    let removeitem = _.differenceWith(this.selected, val, (oth, ath) => {
                        return this.catKeyVal(oth) == this.catKeyVal(ath)
                    })
                    if (removeitem[0] && removeitem[0].class_name) {
                        removeitem[0].class_name = removeitem[0].class_name.replace(`sortable-tr-chosen`, ``)
                    }
                } else if (val.length > 0) {
                    let additem = _.differenceWith(val, this.selected, (oth, ath) => {
                        return this.catKeyVal(oth) == this.catKeyVal(ath)
                    })
                    if (additem[0]) {
                        additem[0].class_name = `${additem[0].class_name || ``} sortable-tr-chosen`
                    }
                }
                this.selected = val
                this.$emit(`extrabutton-click`, { emit: `selectionChange`, row: val, area: `list` })
            }
        },
        filter_option(item, row) {
            if (item.options && _.isFunction(item.options)) {
                return item.options(this, { row: row, column: item, area: `list` })
            }
            return item.options
        },
        filter_readonly(column, row) {
            if (column.readonly == true) {
                return true
            }

            if (row.active) {
                if (column.activereadonly == true) {
                    return true
                }
                if (column.activereadonly && _.isFunction(column.activereadonly)) {
                    return column.activereadonly(this, { row: row, column, area: `list` })
                }
                return false
            }
            if (column.isDisplayOrder || column.type == `buttongroup`) return false // todo：暂时特殊处理
            if (this.active_row == this.catKeyVal(row) || column.type == `checkbox`) {
                if (column.readonly && _.isFunction(column.readonly)) {
                    return column.readonly(this, { row: row, column, area: `list` })
                }
                // if(column.type=='remoteselect'||column.type=='remotemultiselect'){ //todo：暂时特殊处理
                //   return  column.readonly||false
                // }
                return column.readonly == undefined || column.readonly == true
            }
            return true
        },
        filter_readonly2(column, row) {
            if (column.readonly == true) {
                return true
            }
            if (row.active) {
                return false
            }
            if (column.isDisplayOrder || column.type == `buttongroup` || this.active_row == this.catKeyVal(row)) return true // todo：暂时特殊处理
            if (column.readonly && _.isFunction(column.readonly)) {
                return column.readonly(this, { row: row, column, area: `list` })
            }
            if (column.type == `checkbox`) {
                return true
            }
            return column.readonly == undefined || column.readonly == true
        },
        rowDrop() {
            if (this.rowDropDisabled) return
            // 行拖拽
            const warppers = document.querySelectorAll(`.el-table__body-wrapper,.el-table__fixed-body-wrapper`)
            let _this = this
            _.forEach(warppers, warpper => {
                let tbody = warpper.querySelector(`tbody`)
                Sortable.create(tbody, {
                    group: { name: warpper.className.indexOf(`el-table__fixed-body-wrapper`) > -1 ? `fixed-listview` : `listview`, push: false },
                    animation: 180,
                    sort: this.sort,
                    fallbackOnBody: true,
                    // forceFallback:false,
                    // handle:"td",
                    dragoverBubble: true,
                    ghostClass: `sortable-tr-ghost`, // 占位符类名，添加样式
                    chosenClass: `sortable-tr-chosen`, // 所选项目的类名，添加样式
                    dragClass: `sortable-tr-drag`, // 拖动项目类名，添加样式,
                    disabled: this.rowDropDisabled,
                    filter: `.ignore-drag`,
                    delay: 0,
                    setData: function(dataTransfer, dragEl) {
                        let draghtml = ` `
                        if (_this.selected && _this.selected.length > 0) {
                            draghtml = _.join(
                                _.map(_this.selected, d => d.drag_html || ` `),
                                `<br/>`
                            )
                        } else {
                            draghtml = _.join(
                                _.map([_this.choosen], d => d.drag_html || ` `),
                                `<br/>`
                            )
                        }
                        var ghost = document.createElement(`div`)
                        ghost.id = `GHOST_LABEL`
                        ghost.style.background = `#ffff`
                        ghost.style.color = `#606266`
                        ghost.style.padding = `20px 10px 20px 15px`
                        ghost.style.fontSize = `16px`
                        // ghost.style.opacity = '1'
                        ghost.style.textAlign = `left`
                        ghost.style.lineHeight = `20px`
                        ghost.innerHTML = draghtml
                        ghost.style.display = `inline`
                        ghost.style.position = `absolute`
                        ghost.style.left = `-2000px`
                        ghost.style.top = `0px`
                        document.body.appendChild(ghost)
                        // var img = new Image();
                        // img.src = 'static/img/defaultImg.jpg';
                        dataTransfer.setDragImage(ghost, -10, -10)
                        // dataTransfer.setDragImage('Text', dragEl.textContent); // `dataTransfer` object of HTML5 DragEvent
                    },
                    onChoose: function(/** Event */ { oldIndex }) {
                        _this.choosen = _this.datalist[oldIndex]
                    },
                    onMove(/** Event */ evt, /** Event */ originalEvent) {
                        let $node = document.getElementsByClassName(`drag_target`)
                        if ($node[0]) {
                            let cls = $node[0].getAttribute(`class`).replace(`drag_target `, ``)
                            $node[0].setAttribute(`class`, cls)
                        }
                        evt.to.setAttribute(`class`, `drag_target ${evt.to.getAttribute(`class`)}`)
                    },
                    onEnd(/** Event */ evt, /** Event */ originalEvent) {
                        document.body.removeChild(document.getElementById(`GHOST_LABEL`))
                        let $node = document.getElementsByClassName(`drag_target`)
                        if ($node[0]) {
                            let cls = $node[0].getAttribute(`class`).replace(`drag_target `, ``)
                            $node[0].setAttribute(`class`, cls)
                        }
                    },
                    onUpdate({ newIndex, oldIndex }) {
                        // 交换排序
                        if (newIndex == oldIndex) return
                        _this.$emit(`exchange-row`, { newrow: _.cloneDeep(_this.datalist[newIndex]), oldrow: _.cloneDeep(_this.datalist[oldIndex]) })
                        const currRow = _this.datalist.splice(oldIndex, 1)[0]
                        _this.datalist.splice(newIndex, 0, currRow)
                    },
                    onRemove({ oldIndex, newIndex }) {
                        if (_this.selected && _this.selected.length > 0) {
                            _.forEach(_this.selected, sd => {
                                let idx = _.findIndex(_this.datalist, dl => {
                                    return _this.catKeyVal(dl) == _this.catKeyVal(sd)
                                })
                                if (idx >= 0) {
                                    _this.datalist.splice(idx, 1)
                                }
                            })
                            _this.$store.commit(`listview/SET_DATA`, [..._this.selected])
                            _this.$refs[`cus-table`].clearSelection()
                            _this.selected = []
                            _this.datalist = []
                        } else {
                            const currRow = _this.datalist.splice(oldIndex, 1)
                            _this.$store.commit(`listview/SET_DATA`, currRow)
                        }
                    }
                })
            })
        },
        columnDrop() {
            // 列拖拽
            const wrapperTr = document.querySelector(`.el-table__header-wrapper tr`)
            this.sortable = Sortable.create(wrapperTr, {
                animation: 180,
                delay: 0,
                onEnd: evt => {}
            })
        },
        loadChildren(tree, treeNode, resolve) {
            this.$emit(`extrabutton-click`, { emit: `loadChildren`, row: tree, resolve })
        },
        clearSelect() {
            this.$refs[`cus-table`].clearSelection()
        },
        rowClass({ row, rowIndex }) {
            if (this.chargeStyle) { // 麻醉计费背景色要求和手术计费统一
                var cls = []
                if ((row && row.class_name)) {
                    cls.push(row.class_name)
                }
                // cls.push(`setbgcolorClass`)
                return cls.join(` `)
            }
            return (row && row.class_name) || ``
        },
        tableRowStyle({ row, rowIndex }) {
            return (row && row.row_style) || {}
        },
        cellClass({ row, column, rowIndex, columnIndex }) {
            let cls = column.property
            if (columnIndex >= this.pre_column_len) {
                if (this.listColumn[columnIndex - this.pre_column_len]) {
                    if (`select,groupselect,multiselect,groupmultiselect,remoteselect,remotemultiselect,remoteselecttable,`.indexOf(`${this.listColumn[columnIndex - this.pre_column_len].type},`) > -1) {
                        cls += ` cus-select`
                    }
                    if (row.cell_class && row.cell_class[column.property]) {
                        cls += ` ${row.cell_class[column.property]}`
                    }
                }
            }
            return cls
        },
        checkedChange(item, index) {
            _.forEach(this.datalist, d => {
                if (d[item.prop] === false || d[item.prop] === true) {
                    d[item.prop] = this.checkboxs[index]
                }
            })
        },
        loadSpanMethod(obj) {
            return (this.spanMethod && this.spanMethod(obj)) || [1, 1]
        },
        sortChange({ column, prop, order }) {
            let that = this
            this.order = order
            that.sortOrder(that.datalist, prop, order)
        },
        sortHandle(a, b, prop, column) {
            let res = 0
            // added by xiaorui,自定义排序函数，需要用到自定义排序的可以在对应列中编写sortChange 功能
            if (column.sortChange && _.isFunction(column.sortChange)) {
                res = column.sortChange(this, { a, b, prop, column })
            } else {
                let str1 = a[prop]
                if (!str1) return 1
                let str2 = b[prop]
                if (!str2) return -1
                if (this.isNumber(str1) && this.isNumber(str2)) {
                    return parseInt(str1) - parseInt(str2)
                }

                if (this.isLableValueObj(str1) && this.isLableValueObj(str2)) {
                    str1 = str1.label
                    str2 = str2.label
                }

                for (let i = 0; ; i++) {
                    if (!str1[i] || !str2[i]) {
                        res = str1.length - str2.length
                        break
                    }
                    const char1 = str1[i]
                    const char1Type = this.getChartType(char1)
                    const char2 = str2[i]
                    const char2Type = this.getChartType(char2)
                    // 类型相同的逐个比较字符
                    if (char1Type[0] === char2Type[0]) {
                        if (char1 === char2) {
                            continue
                        } else {
                            if (char1Type[0] === `zh`) {
                                res = char1.localeCompare(char2, `zh-CN`)
                            } else if (char1Type[0] === `en`) {
                                res = char1.charCodeAt(0) - char2.charCodeAt(0)
                            } else {
                                if (str1.length == str2.length) {
                                    res = char1 - char2
                                } else {
                                    res = str1.length - str2.length
                                }
                            }
                            break
                        }
                    } else {
                    // 类型不同的，直接用返回的数字相减
                        res = char1Type[1] - char2Type[1]
                        break
                    }
                }
            }

            return res
        },
        getChartType(char) {
            // 数字（0->9）->大写字母（A->Z）->小写字母（a->z）->中文拼音（a->z）
            if (/^[\u4e00-\u9fa5]$/.test(char)) {
                return [`zh`, 300]
            }
            if (/^[a-zA-Z]$/.test(char)) {
                return [`en`, 200]
            }
            if (/^[0-9]$/.test(char)) {
                return [`number`, 100]
            }
            return [`others`, 999]
        },
        isNumber(val) {
            var regPos = /^\d+(\.\d+)?$/
            var regNeg = /^(-(([0-9]+\.[0-9]*[1-9][0-9]*)|([0-9]*[1-9][0-9]*\.[0-9]+)|([0-9]*[1-9][0-9]*)))$/ // 负浮点数
            if (regPos.test(val) || regNeg.test(val)) {
                return true
            } else {
                return false
            }
        },
        isLableValueObj(obj) {
            return typeof obj == `object` && _.has(obj, `value`) && _.has(obj, `label`)
        },

        setDefaultSort(prop, order) {
            this.defaultSort.prop = prop || ``
            this.defaultSort.order = this.parseSortOrder(order)
        },
        showCount(item) {
            // if (!item || !item.showCount) { return 1 }
            // return item.showCount
            return 1
        },
        parseSortOrder(order) {
            return typeof order === `boolean` ? (order ? `ascending` : `descending`) : order
        },
        // added by xiaorui,点击排序后调用排序
        sortOrder(datalist, prop, order) {
            let that = this
            datalist.sort(function(c, d) {
                let res = 0
                let str1 = order == `descending` ? d[prop] : c[prop]
                let str2 = order == `descending` ? c[prop] : d[prop]
                if (!str1) return 1
                if (!str2) return -1

                if (that.isNumber(str1) && that.isNumber(str2)) {
                    return parseInt(str1) - parseInt(str2)
                }

                if (that.isLableValueObj(str1) && that.isLableValueObj(str2)) {
                    str1 = str1.label
                    str2 = str2.label
                }

                for (let i = 0; ; i++) {
                    if (!str1[i] || !str2[i]) {
                        res = str1.length - str2.length
                        break
                    }
                    const char1 = str1[i]
                    const char1Type = that.getChartType(char1)
                    const char2 = str2[i]
                    const char2Type = that.getChartType(char2)
                    // 类型相同的逐个比较字符
                    if (char1Type[0] === char2Type[0]) {
                        if (char1 === char2) {
                            continue
                        } else {
                            if (char1Type[0] === `zh`) {
                                res = char1.localeCompare(char2, `zh-CN`)
                            } else if (char1Type[0] === `en`) {
                                res = char1.charCodeAt(0) - char2.charCodeAt(0)
                            } else {
                                if (str1.length == str2.length) {
                                    res = char1 - char2
                                } else {
                                    res = str1.length - str2.length
                                }
                            }
                            break
                        }
                    } else {
                        // 类型不同的，直接用返回的数字相减
                        res = char1Type[1] - char2Type[1]
                        break
                    }
                }

                return res
            })
        }
    },
    watch: {
        _tableHeight: function() {
            this.setTableheight(0)
        },
        hasFixed: function() {
            this.setTableheight(0)
        }
    }
}
</script>
<style  lang="less">
// .el-table__header{
//   border-bottom:solid gray 0.5px !important;
// }
.el-table .caret-wrapper {
    height: 33px;
}
// .sortable-tr-drag{
//   opacity:1;
//   color: royalblue;
//   td:not(1){
//     display: none;
//   }
// }
// .sortable-tr-ghost td{
//   background: red !important;
// color:red;
// }
.sortable-tr-chosen td {
    // opacity:0.4 !important;
    background: var(--primary-lighter, rgba(0, 150, 136, 0.2)) !important; //rgba(0,150,136,0.2)
}
.cus-select .cell {
    overflow: visible !important;
}
.multiselect,
.groupmultiselect,
.remotemultiselect {
    // .el-input__inner {
    //   padding-left: 5px;
    // }
    .el-input--suffix .el-input__inner {
        padding-right: 5px !important;
    }
    .el-input__suffix {
        display: none !important;
    }
    .el-select__tags .el-select__input {
        margin-left: 5px;
    }
}
.el-table__body-wrapper {
    z-index: 2;
}
// .setbgcolorClass {
//     background: #cdeae8 !important;
// }
.cursorstyle {
    cursor: pointer;
}
</style>
<style scoped>
.table-expand {
    font-size: 0;
}
.expand-label {
    color: #909399;
}
.el-table th > .cell {
    text-align: center !important;
}
.charge-row {
    background-color: #2fb4c8 !important;
}
</style>



// WEBPACK FOOTER //
// src/common/ListView.vue